import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-html-dialog',
  templateUrl: './html-dialog.component.html',
  styleUrl: './html-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton],
})
export class HtmlDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<HtmlDialogComponent>>(MatDialogRef);
  data = inject<{
    title: string;
    html: SafeHtml;
    dialog_close_button: string;
  }>(MAT_DIALOG_DATA);

  ngOnInit(): void {}

  close() {
    this.dialogRef.close();
  }
}
